export default __webpack_public_path__ + "static/media/cv151-1.41e21c1f.png";